import { useEffect, useRef } from 'react';
import { animate, stagger, utils } from 'animejs';

interface AnimeRevealOptions {
  delay?: number;
  translateY?: number;
  duration?: number;
}

/** One-shot anime.js fade/slide for hero brand & CTA (anime.js v4). */
export function useAnimeReveal<T extends HTMLElement>(options: AnimeRevealOptions = {}) {
  const ref = useRef<T | null>(null);
  const {
    delay = 80,
    translateY = 28,
    duration = 900,
  } = options;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const targets = el.querySelectorAll('[data-anime]');
    if (!targets.length) return;

    utils.set(targets, { opacity: 0, translateY });

    animate(targets, {
      opacity: [0, 1],
      translateY: [translateY, 0],
      ease: 'out(3)',
      duration,
      delay: stagger(delay),
    });
  }, [delay, translateY, duration]);

  return ref;
}
